<template>
  <div style="padding-right:1%; border-right: 1px solid gray">
    <!-- header -->
    <div style="display:flex">
      <div class="column20 border border-dark flex-center" style="height:auto">
        <img src="../../../assets/img/pdf/bce.jpg" height="60px" />
      </div>
      <div class="column80">
        <div class="border-top border-right border-dark text-center">
          BERAU COAL GREEN MINING SYSTEM
        </div>
        <div class="border-top border-right border-dark text-center">
          FORMULIR
        </div>
        <div class="border-top border-bottom border-right border-dark text-center">
          PRAKUALIFIKASI K3L
        </div>
      </div>
    </div>
    <!-- Detail A-->
    <div class="border-left border-right border-dark" style="padding:10px">

      <Head :title="'A. INFORMASI PRAQUALIFIKASI K3L'" />
      <Row :indexRow="'A.1'" :desc="'No. Penilaian'" :value_1="code" :addBorder="false" :value_2="null" />
      <Row :indexRow="'A.2'" :desc="'Tanggal Diterima'" :value_1="created_at" :addBorder="false" :value_2="null" />
      <Row :indexRow="'A.3'" :desc="'Tanggal Penilaian'" :value_1="updated_at" :addBorder="false" :value_2="null" />
      <Row :indexRow="'A.4'" :desc="'Berlaku Sampai Tanggal'" :value_1="tgl_berlaku" :addBorder="false"
        :value_2="null" />
    </div>

    <!-- Detail B-->
    <div class="border-left border-right border-dark" style="padding:10px">

      <Head :title="'B. INFORMASI PERUSAHAAN'" />
      <Row :indexRow="'B.1'" :desc="'Nama Perusahaan'" :value_1="vendor_name" :addBorder="false" :value_2="null" />
      <Row :indexRow="'B.2'" :desc="'Tanggal Berdiri'" :value_1="tgl_berdiri" :addBorder="false" :value_2="null" />
      <Row :indexRow="'B.3'" :desc="'Alamat Perusahaan'" :value_1="alamat" :addBorder="false" :value_2="null" />
      <Row :indexRow="'B.4'" :desc="'Negara'" :value_1="negara" :addBorder="false" :value_2="null" />
      <Row :indexRow="'B.5'" :desc="'Provinsi'" :value_1="provinsi" :addBorder="false" :value_2="null" />
      <Row :indexRow="'B.6'" :desc="'Kota'" :value_1="kota" :addBorder="false" :value_2="null" />
      <Row :indexRow="'B.7'" :desc="'Kecamatan'" :value_1="kecamatan" :addBorder="false" :value_2="null" />
      <Row :indexRow="'B.8'" :desc="'Kelurahan'" :value_1="kelurahan" :addBorder="false" :value_2="null" />
      <Row :indexRow="'B.9'" :desc="'Jenis Badan Usaha'" :value_1="jenis_bu" :addBorder="false" :value_2="null" />
      <Row :indexRow="'B.10'" :desc="'Email Perusahaan'" :value_1="email_vendor" :addBorder="false" :value_2="null" />
      <Row :indexRow="'B.11'" :desc="'Perwakilan Perusahaan'" :value_1="pic_name" :addBorder="false" :value_2="null" />
      <Row :indexRow="'B.12'" :desc="'Posisi'" :value_1="pic_position" :addBorder="false" :value_2="null" />
      <Row :indexRow="'B.13'" :desc="'Surel'" :value_1="pic_email" :addBorder="false" :value_2="null" />
      <Row :indexRow="'B.14'" :desc="'Nomor Telp'" :value_1="nomor_hp" :addBorder="false" :value_2="null" />
      <Row :indexRow="'B.15'" :desc="'Apakah Perusahaan Memiliki Kantor Tetap di'"
        :value_1="'Konsensi PKP2B Berau Coal'" :addBorder="true" :value_2="is_pkp2b ? 'Yes' : 'No'" />
      <Row :indexRow="''" :desc="''" :value_1="'Kabupaten Berau'" :addBorder="true"
        :value_2="is_berau ? 'Yes' : 'No'" />
      <Row :indexRow="''" :desc="''" :value_1="'Indonesia'" :addBorder="true" :value_2="is_indonesia ? 'Yes' : 'No'" />

      <Head :title="'B.16 Anak Perusahaan'" />
      <div style="display:flex">
        <div class="p-1 border column5" style="height:auto">NO</div>
        <div class="p-1 text-center border column20 col-nohover" style="height:auto">
          NAMA ANAK PERUSAHAAN
        </div>
        <div class="p-1 text-center border column20 col-nohover" style="height:auto">
          NAMA KONTAK
        </div>
        <div class="p-1 text-center border column15 col-nohover" style="height:auto">
          POSISI
        </div>
        <div class="p-1 text-center border column20 col-nohover" style="height:auto">
          TELEPON
        </div>
        <div class="p-1 text-center border column20 col-nohover" style="height:auto">
          EMAIL
        </div>
      </div>
      <div style="display:flex;" v-for="(list, index) in child_companies" :key="list.id">
        <div class="p-1 border column5 col-nohover" style="height:auto">
          {{ index + 1 }}
        </div>
        <div class="p-1 border column20 col-nohover" style="height:auto">
          {{ $get(list, 'company_name', '-') }}
        </div>
        <div class="p-1 border column20 col-nohover" style="height:auto">
          {{ list.contact_name }}
        </div>
        <div class="p-1 border column15 col-nohover" style="height:auto">
          {{ $get(list, 'position', '-') }}
        </div>
        <div class="p-1 border column20 col-nohover" style="height:auto">
          {{ phone_code }} {{ $get(list, 'phone', '-') }}
        </div>
        <div class="p-1 border column20 col-nohover" style="height:auto">
          {{ $get(list, 'email', '-') }}
        </div>
      </div>

      <Head :title="'B.17 Induk Perusahaan'" />
      <div style="display:flex">
        <div class="p-1 border column5 col-nohover" style="height:auto">NO</div>
        <div class="p-1 text-center border column20 col-nohover" style="height:auto">
          NAMA ANAK PERUSAHAAN
        </div>
        <div class="p-1 text-center border column20 col-nohover" style="height:auto">
          NAMA KONTAK
        </div>
        <div class="p-1 text-center border column15 col-nohover" style="height:auto">
          POSISI
        </div>
        <div class="p-1 text-center border column20 col-nohover" style="height:auto">
          TELEPON
        </div>
        <div class="p-1 text-center border column20 col-nohover" style="height:auto">
          EMAIL
        </div>
      </div>
      <div style="display:flex;" v-for="(list, index) in parent_companies" :key="list.id">
        <div class="p-1 border column5 col-nohover" style="height:auto">
          {{ index + 1 }}
        </div>
        <div class="p-1 border column20 col-nohover" style="height:auto">
          {{ $get(list, 'company_name', '-') }}
        </div>
        <div class="p-1 border column20 col-nohover" style="height:auto">
          {{ list.contact_name }}
        </div>
        <div class="p-1 border column15 col-nohover" style="height:auto">
          {{ $get(list, 'position', '-') }}
        </div>
        <div class="p-1 border column20 col-nohover" style="height:auto">
          {{ phone_code }} {{ $get(list, 'phone', '-') }}
        </div>
        <div class="p-1 border column20 col-nohover" style="height:auto">
          {{ $get(list, 'email', '-') }}
        </div>
      </div>
    </div>

    <!-- Detail C -->
    <div class="border-left border-right border-dark" style="padding:10px">

      <Head :title="'C. BIDANG USAHA UTAMA'" />
      <div style="display:flex">
        <div class="p-1 border column5">NO</div>
        <div class="p-1 text-center border column30">KODE</div>
        <div class="p-1 text-center border column65">BIDANG</div>
      </div>
      <div style="display:flex;" v-for="(list, index) in usaha_utama" :key="index + 5000">
        <div class="p-1 border column5 col-nohover" style="height: auto">
          {{ index + 1 }}
        </div>
        <div class="p-1 border column30 col-nohover" style="height: auto">
          {{ $get(list, 'kbli_sub.kode', '-') }}
        </div>
        <div class="p-1 border column65 col-nohover" style="height: auto">
          {{ $get(list, 'kbli_sub.desc', '-') }}
        </div>
      </div>
    </div>

    <!-- Detail C -->
    <div class="border-left border-right border-dark" style="padding:10px">

      <Head :title="'C. BIDANG USAHA JASA INTI'" />
      <div style="display:flex">
        <div class="p-1 border column5">NO</div>
        <div class="p-1 text-center border column30">JENIS</div>
        <div class="p-1 text-center border column30">BIDANG</div>
        <div class="p-1 text-center border column35">SUB BIDANG</div>
      </div>
      <div style="display:flex;" v-for="(list, index) in usaha_inti" :key="index * 1000">
        <div class="p-1 border column5">{{ index + 1 }}</div>
        <div class="p-1 border column30">
          {{ $get(list, 'master_iujp.jenis', '-') }}
        </div>
        <div class="p-1 border column30">
          {{ $get(list, 'master_iujp.bidang', '-') }}
        </div>
        <div class="p-1 border column35">
          {{ $get(list, 'master_iujp.sub_bidang', '-') }}
        </div>
      </div>
    </div>

    <!-- Detail D -->
    <div class="border-left border-right border-dark" style="padding:10px">

      <Head :title="'D. BIDANG USAHA NON INTI'" />
      <div style="display:flex">
        <div class="p-1 border column5">NO</div>
        <div class="p-1 text-center border column45">BIDANG</div>
        <div class="p-1 text-center border column50">PENJELASAN</div>
      </div>
      <div style="display:flex;" v-for="(list, index) in usaha_non_inti" :key="index * 1000">
        <div class="p-1 border column5">{{ index + 1 }}</div>
        <div class="p-1 border column45">
          {{ $get(list, 'desc', '-') }}
        </div>
        <div class="p-1 border column50">
          {{ $get(list, 'undefined', '-') }}
        </div>
      </div>
    </div>

    <!-- Detail E -->
    <div class="border-left border-right border-dark" style="padding:10px">

      <Head :title="'E. KOMPETENSI & SUMBERDAYA MANUSIA'" />
      <div style="display:flex">
        <div class="p-1 border column5" style="height:auto">NO</div>
        <div class="p-1 text-center border column15 col-nohover" style="height:auto">
          POSISI
        </div>
        <div class="p-1 text-center border column15 col-nohover" style="height:auto">
          JUMLAH KARYAWAN
        </div>
        <div class="p-1 text-center border column35 col-nohover" style="height:auto">
          KOMPETENSI KHUSUS / UMUM
        </div>
        <div class="p-1 text-center border column35 col-nohover" style="height:auto">
          PENGALAMAN KERJA
        </div>
      </div>
      <div style="display:flex;" v-for="(list, index) in sertifikat_karyawan" :key="list.id">
        <div class="p-1 border column5" style="height:auto">
          {{ index + 1 }}
        </div>
        <div class="p-1 border column15 col-nohover" style="height:auto">
          {{ $get(list, 'posisi', '-') }}
        </div>
        <div class="p-1 border column15" style="height:auto">
          {{ $get(list, 'jumlah', '-') }}
        </div>
        <div class="p-1 border column35" style="height:auto">
          {{ $get(list, 'umum_khusus', '-') }}
        </div>
        <div class="p-1 border column35" style="height:auto">
          {{ $get(list, 'pengalaman_kerja', '-') }} Tahun
        </div>
      </div>
    </div>

    <!-- Detail F -->
    <div class="border-left border-right border-dark" style="padding:10px">

      <Head :title="'F. PENGELOLAAN K3L'" />
      <SubHead :title="'1. KEBIJAKAN, KEPEMIMPINAN & KOMITMEN'" />
      <PengelolaanK3lTable :indexRow="'1.1'" :desc="'Berikan penjelasan rinci mengenai komitmen pimpinan perusahaan melalui Kebijakan Kesehatan, Keselamatan Kerja dan Lingkungan (K3L) dan Kebijakan Khusus lainnya di perusahaan anda.'
        " :value="penjelasan_11" />

      <SubHead :title="'2. MANAJEMEN RISIKO'" />
      <PengelolaanK3lTable :indexRow="'2.1'" :desc="'Berikan penjelasan rinci pengaturan mengenai pengelolaan Manajemen Risiko (HIRA) di perusahaan anda.'
        " :value="penjelasan_21" />
      <PengelolaanK3lTable :indexRow="'2.2'" :desc="'Berikan penjelasan rinci mengenai aktivitas/ kegiatan apa saja yang telah dilakukan Analisis risiko (HIRA) dan Analisa Keselamatan Kerja (JSA) berikut pengendaliannya.'
        " :value="penjelasan_22" />

      <SubHead :title="'3. MANUAL K3L'" />
      <PengelolaanK3lTable :indexRow="'3.1'" :desc="'Berikan penjelasan rinci mengenai Manual atau Pedoman Sistem Pengelolaan K3L sesuai lingkup operasional perusahaan.'
        " :value="penjelasan_31" />

      <SubHead :title="'4. PENGELOLAAN B3'" />
      <PengelolaanK3lTable :indexRow="'4.1'" :desc="'Berikan penjelasan rinci mengenai pengelolaan Bahan Berbahaya dan Beracun (B3) diperusahaan anda.'
        " :value="penjelasan_41" />

      <SubHead :title="'5. PENGELOLAAN LIMBAH'" />
      <PengelolaanK3lTable :indexRow="'5.1'" :desc="'Berikan penjelasan rinci mengenai pengelolaan limbah (padat, cair dan gas) dan limbah B3 diperusahaan anda'
        " :value="penjelasan_51" />

      <SubHead :title="'6. PENCEGAHAN KECELAKAAN FATAL (GOLDEN RULES)'" />
      <PengelolaanK3lTable :indexRow="'6.1'" :desc="'Kegiatan apa saja yang ada di perusahaan anda yang terkait dengan Golden Rules PT Berau Coal'
        " :value="penjelasan_61" />

      <SubHead :title="'7. SERTIFIKASI SISTEM MANAJEMEN'" />
      <div>
        <div style="display:flex; background-color:rgb(204,255,179)">
          <div class="p-1 border border-dark column5">NO</div>
          <div class="p-1 text-center border border-left-0 border-dark column35">
            SISTEM MANAJEMEN / LINGKUP AUDIT
          </div>
          <div class="p-1 text-center border border-left-0 border-dark column30">
            ORGANISASI PIHAK KETIGA
          </div>
          <div class="p-1 text-center border border-left-0 border-dark column30">
            MASA BERLAKU
          </div>
        </div>
        <div style="display:flex;" v-for="(list, index) in system_manajement" :key="list.id">
          <div class="p-1 border border-dark column5" style="height: auto">
            {{ index + 1 }}
          </div>
          <div class="p-1 text-center border border-left-0border-dark column35" style="height: auto">
            {{ $get(list, 'lingkup_audit', '-') }}
          </div>
          <div class="p-1 text-center border border-left-0 border-dark column30" style="height: auto">
            {{ $get(list, 'third_party', '-') }}
          </div>
          <div class="p-1 text-center border border-left-0 border-dark column30" style="height: auto">
            {{ $get(list, 'masa_berlaku', '-') }} Tahun
          </div>
        </div>
      </div>

      <SubHead :title="'8. KINERJA K3L'" />
      <PengelolaanK3lTable :indexRow="'8.1'" :desc="'Berikan penjelasan rinci mengenai Kinerja K3L serta statistik unjuk kerja keselamatan (angka Frequency Rates “FR” per 1,000,000 jam kerja). *Jumlah kecelakaan berdampak Fatality (FT), Major, Minor Injuries, Medical Treatment Injury (MTI), Restricted Working Injury (RWI), First Aid (FA).'
        " :value="penjelasan_81" />
      <PengelolaanK3lTable :indexRow="'8.2'" :desc="'Berikan penjelasan bila perusahaan mengalami kecelakaan berdampak LTI (Lost Time Injury) atau pelanggaran lingkungan akibat dari tindakan Perusahaan, Sub-kontraktor anda atau orang lain yang bertindak atas nama Perusahaan anda selama 3 tahun terakhir.'
        " :value="penjelasan_82" />
      <div class="column100 border-top border-dark"></div>
    </div>

    <!-- TABLE PENILAIAN -->
    <div class="border-left border-right border-dark" style="padding:10px">

      <Head :title="'G. PRAQUALIFIKASI K3L'" />
      <div style="display:flex; background-color:rgb(102,255,102); height:100%">
        <div class="p-1 border border-dark flex-center" style="height:auto; width:28%">
          KATEGORI
        </div>
        <div class="p-1 border border-left-0 border-dark column5 col-nohover flex-center" style="height:auto">
          A
        </div>
        <div class="p-1 border border-left-0 border-dark column5 col-nohover flex-center" style="height:auto">
          B
        </div>
        <div class="p-1 border border-left-0 border-dark column5 col-nohover flex-center" style="height:auto">
          C
        </div>
        <div class="p-1 border border-left-0 border-dark col-nohover flex-center text-center"
          style="height:auto; width: 7%">
          SUB TOTAL
        </div>
        <div class="p-1 border border-left-0 border-dark col-nohover text-center flex-center"
          style="height:auto; width:7%">
          % Bobot
        </div>
        <div class="p-1 border border-left-0 border-dark col-nohover text-center" style="height:auto; width: 8%">
          % Actual Bobot
        </div>
        <div class="p-1 border border-left-0 border-dark column15 flex-center align-bottom" style="height:auto">
          TOTAL
        </div>
        <div class="p-1 border border-left-0 border-dark flex-center" style="height:auto; width:20%">
          CATATAN
        </div>
      </div>

      <Head :title="'G.1 DOKUMEN PERIZINAN PERUSAHAAN'" :subtitle="'20.0%'" />
      <div class="border border-dark" style="display:flex">
        <div class="p-1 column5 border border-top-0 border-left-0 border-dark  text-center text-bold"
          style="height:auto">
          1
        </div>
        <div style="width:95%">
          <subtitle-penilaian :subtitle="'IUJP/SIUP'" />
          <table-detail-penilaian :name="'ITEM 1.1'" :indicator="{ a: '0', b: '-', c: '5' }" :bobot="'25.0'"
            :subtotal="izin_11" :note="note_izin_11" :new_actual="actual_izin_11" :max_value="20" />
          <table-detail-penilaian :name="'ITEM 1.2'" :indicator="{ a: '0', b: '-', c: '15' }" :bobot="'75.0'"
            :subtotal="izin_12" :note="note_izin_12" :new_actual="actual_izin_12" :max_value="20" />
        </div>
      </div>
      <sub-total :subtotal="rating_result_1" />

      <Head :title="'G.2 KOMPETENSI & SUMBERDAYA MANUSIA'" :subtitle="'15.0%'" />
      <div class="border border-dark" style="display:flex;">
        <div class="p-1 column5 border border-top-0 border-left-0 border-dark text-center text-bold"
          style="height:auto">
          1
        </div>
        <div style="width:95%">
          <subtitle-penilaian :subtitle="'KOMPETENSI UMUM'" />
          <table-detail-penilaian :name="'ITEM 1.1'" :indicator="{ a: '0', b: '3', c: '5' }" :bobot="'33.33'"
            :subtotal="sertifikat_11" :note="note_sertifikat_11" :new_actual="actual_sertifikat_11" :max_value="15" />
        </div>
      </div>
      <div class="border border-dark" style="display:flex">
        <div class="p-1 column5 border border-top-0 border-left-0 border-dark  text-center text-bold"
          style="height:auto">
          2
        </div>
        <div style="width:95%">
          <subtitle-penilaian :subtitle="'KOMPETENSI KHUSUS'" />
          <table-detail-penilaian :name="'ITEM 1.1'" :indicator="{ a: '0', b: '3', c: '5' }" :bobot="'33.33'"
            :subtotal="sertifikat_12" :note="note_sertifikat_12" :new_actual="actual_sertifikat_12" :max_value="15" />
          <table-detail-penilaian :name="'ITEM 1.2'" :indicator="{ a: '0', b: '3', c: '5' }" :bobot="'33.33'"
            :subtotal="sertifikat_13" :note="note_sertifikat_13" :new_actual="actual_sertifikat_13" :max_value="15" />
        </div>
      </div>
      <sub-total :subtotal="rating_result_2" />

      <Head :title="'G.3 PENGELOLAAN K3L'" :subtitle="'65.0%'" />
      <div class="border border-dark" style="display:flex">
        <div class="p-1 column5 border border-top-0 border-left-0 border-dark text-center text-bold"
          style="height:auto">
          1
        </div>
        <div style="width:95%">
          <subtitle-penilaian :subtitle="'KEBIJAKAN, KEPEMIMPINAN & KOMITMEN'" />
          <table-detail-penilaian :name="'ITEM 1.1'" :indicator="{ a: '0', b: '3', c: '5' }" :bobot="'7.70'"
            :subtotal="penilaian_grup1_11" :note="note_grup1_11" :new_actual="actual_penilaian_grup1_11"
            :max_value="65" />
        </div>
      </div>
      <div class="border border-dark" style="display:flex">
        <div class="p-1 column5 border border-top-0 border-left-0 border-dark text-center text-bold"
          style="height:auto">
          2
        </div>
        <div style="width:95%">
          <subtitle-penilaian :subtitle="'MANAJEMEN RISIKO'" />
          <table-detail-penilaian :name="'ITEM 1.1'" :indicator="{ a: '0', b: '3', c: '5' }" :bobot="'7.70'"
            :subtotal="penilaian_grup2_11" :note="note_grup2_11" :new_actual="actual_penilaian_grup2_11"
            :max_value="65" />
          <table-detail-penilaian :name="'ITEM 1.2'" :indicator="{ a: '0', b: '3', c: '5' }" :bobot="'7.70'"
            :subtotal="penilaian_grup2_12" :note="note_grup2_12" :new_actual="actual_penilaian_grup2_12"
            :max_value="65" />
        </div>
      </div>
      <div class="border border-dark" style="display:flex">
        <div class="p-1 column5 border border-top-0 border-left-0 border-dark text-center text-bold"
          style="height:auto">
          3
        </div>
        <div style="width:95%">
          <subtitle-penilaian :subtitle="'MANUAL K3L'" />
          <table-detail-penilaian :name="'ITEM 1.1'" :indicator="{ a: '0', b: '3', c: '5' }" :bobot="'7.70'"
            :subtotal="penilaian_grup3_11" :note="note_grup3_11" :new_actual="actual_penilaian_grup3_11"
            :max_value="65" />
        </div>
      </div>
      <div class="border border-dark" style="display:flex">
        <div class="p-1 column5 border border-top-0 border-left-0 border-dark text-center text-bold"
          style="height:auto">
          4
        </div>
        <div style="width:95%">
          <subtitle-penilaian :subtitle="'PENGELOLAAN B3'" />
          <table-detail-penilaian :name="'ITEM 1.1'" :indicator="{ a: '0', b: '3', c: '5' }" :bobot="'7.70'"
            :subtotal="penilaian_grup4_11" :note="note_grup4_11" :new_actual="actual_penilaian_grup4_11"
            :max_value="65" />
        </div>
      </div>
      <div class="border border-dark" style="display:flex">
        <div class="p-1 column5 border border-top-0 border-left-0 border-dark text-center text-bold"
          style="height:auto">
          5
        </div>
        <div style="width:95%">
          <subtitle-penilaian :subtitle="'PENGELOLAAN LIMBAH'" />
          <table-detail-penilaian :name="'ITEM 1.1'" :indicator="{ a: '0', b: '3', c: '5' }" :bobot="'7.70'"
            :subtotal="penilaian_grup5_11" :note="note_grup5_11" :new_actual="actual_penilaian_grup5_11"
            :max_value="65" />
        </div>
      </div>
      <div class="border border-dark" style="display:flex">
        <div class="p-1 column5 border border-top-0 border-left-0 border-dark text-center text-bold"
          style="height:auto">
          6
        </div>
        <div style="width:95%">
          <subtitle-penilaian :subtitle="'PENCEGAHAN KECELAKAAN FATAL (GOLDEN RULES)'" />
          <table-detail-penilaian :name="'ITEM 1.1'" :indicator="{ a: '0', b: '3', c: '5' }" :bobot="'7.70'"
            :subtotal="penilaian_grup6_11" :note="note_grup6_11" :new_actual="actual_penilaian_grup6_11"
            :max_value="65" />
          <table-detail-penilaian :name="'ITEM 1.2'" :indicator="{ a: '0', b: '5', c: '10' }" :bobot="'15.40'"
            :subtotal="penilaian_grup6_12" :note="note_grup6_12" :new_actual="actual_penilaian_grup6_12"
            :max_value="65" />
        </div>
      </div>
      <div class="border border-dark" style="display:flex">
        <div class="p-1 column5 border border-top-0 border-left-0 border-dark text-center text-bold"
          style="height:auto">
          7
        </div>
        <div style="width:95%">
          <subtitle-penilaian :subtitle="'SERTIFIKASI SISTEM MANAJEMEN'" />
          <table-detail-penilaian :name="'ITEM 1.1'" :indicator="{ a: '0', b: '3', c: '5' }" :bobot="'7.70'"
            :subtotal="penilaian_grup7_11" :note="note_grup7_11" :new_actual="actual_penilaian_grup7_11"
            :max_value="65" />
          <table-detail-penilaian :name="'ITEM 1.2'" :indicator="{ a: '0', b: '5', c: '10' }" :bobot="'15.40'"
            :subtotal="penilaian_grup7_12" :note="note_grup7_12" :new_actual="actual_penilaian_grup7_12"
            :max_value="65" />
        </div>
      </div>
      <div class="border border-dark" style="display:flex">
        <div class="p-1 column5 border border-top-0 border-left-0 border-dark text-center text-bold"
          style="height:auto">
          8
        </div>
        <div style="width:95%">
          <subtitle-penilaian :subtitle="'KINERJA K3L'" />
          <table-detail-penilaian :name="'ITEM 1.1'" :indicator="{ a: '0', b: '3', c: '5' }" :bobot="'7.70'"
            :subtotal="penilaian_grup8_11" :note="note_grup8_11" :new_actual="actual_penilaian_grup8_11"
            :max_value="65" />
        </div>
      </div>
      <sub-total :subtotal="rating_result_3" />
      <total :total="grand_total" />
      <tingkat-risiko :kategori="kategori" />
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { api } from '@/services/config'
import moment from 'moment'
export default {
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
    Row: () => import('@/components/molecules/atoms/rowTableK3l.vue'),
    Head: () => import('@/components/molecules/atoms/tableHeader.vue'),
    PengelolaanK3lTable: () =>
      import('@/components/molecules/atoms/tablePengelolaanK3L.vue'),
    SubHead: () =>
      import('@/components/molecules/atoms/subHeadPengelolaanK3L.vue'),
    SubTotal: () => import('@/components/molecules/atoms/subTotal.vue'),
    total: () => import('@/components/molecules/atoms/tableTotal.vue'),
    TingkatRisiko: () =>
      import('@/components/molecules/atoms/tingkatRisiko.vue'),
    TableDetailPenilaian: () =>
      import('@/components/molecules/atoms/tableDetailPenilaian.vue'),
    SubtitlePenilaian: () =>
      import('@/components/molecules/atoms/subtitlePenilaian.vue'),
  },
  created() {
    const status = this.$route.params.status
    this.getFullRequest(this.$route.params.id)
  },
  data() {
    return {
      code: '',
      created_at: '',
      updated_at: '',
      tgl_berlaku: '',

      vendor_name: '-',
      email_vendor: '-',
      tgl_berdiri: '-',
      alamat: '-',
      negara: '-',
      provinsi: '-',
      kota: '-',
      kecamatan: '-',
      kelurahan: '-',
      jenis_bu: '-',
      pic_name: '-',
      pic_position: '-',
      pic_email: '-',
      nomor_hp: '-',
      phone: '-',
      phone_code: '-',
      is_pkp2b: false,
      is_berau: false,
      is_indonesia: false,

      parent_companies: [],
      child_companies: [],

      usaha_inti: [],
      usaha_non_inti: [],
      usaha_utama: [],
      sertifikat_karyawan: [],
      system_manajement: [],

      penjelasan_11: '-',
      penjelasan_21: '-',
      penjelasan_22: '-',
      penjelasan_31: '-',
      penjelasan_41: '-',
      penjelasan_51: '-',
      penjelasan_61: '-',
      penjelasan_81: '-',
      penjelasan_82: '-',

      izin_11: '-',
      izin_12: '-',
      actual_izin_11: 0,
      actual_izin_12: 0,
      sertifikat_11: '-',
      sertifikat_12: '-',
      sertifikat_13: '-',
      actual_sertifikat_11: 0,
      actual_sertifikat_12: 0,
      actual_sertifikat_13: 0,

      penilaian_grup1_11: '-',
      actual_penilaian_grup1_11: 0,

      penilaian_grup2_11: '-',
      penilaian_grup2_12: '-',
      actual_penilaian_grup2_11: 0,
      actual_penilaian_grup2_12: 0,

      penilaian_grup3_11: '-',
      actual_penilaian_grup3_11: 0,

      penilaian_grup4_11: '-',
      actual_penilaian_grup4_11: 0,

      penilaian_grup5_11: '-',
      actual_penilaian_grup5_11: 0,

      penilaian_grup6_11: '-',
      penilaian_grup6_12: '-',
      actual_penilaian_grup6_11: 0,
      actual_penilaian_grup6_12: 0,

      penilaian_grup7_11: '-',
      penilaian_grup7_12: '-',
      actual_penilaian_grup7_11: 0,
      actual_penilaian_grup7_12: 0,

      penilaian_grup8_11: '-',
      actual_penilaian_grup8_11: 0,

      note_izin_11: '-',
      note_izin_12: '-',
      note_sertifikat_11: '-',
      note_sertifikat_12: '-',
      note_sertifikat_13: '-',
      note_grup1_11: '-',
      note_grup2_11: '-',
      note_grup2_12: '-',
      note_grup3_11: '-',
      note_grup4_11: '-',
      note_grup5_11: '-',
      note_grup6_11: '-',
      note_grup6_12: '-',
      note_grup7_11: '-',
      note_grup7_12: '-',
      note_grup8_11: '-',

      rating_result_1: '-',
      rating_result_2: '-',
      rating_result_3: '-',
      grand_total: '-',
      kategori: '-',
    }
  },
  methods: {
    async getFullRequest(id) {
      try {
        this.$store.commit('SET_GLOBAL_LOADING', true)

        const { data } = await axios({
          method: 'GET',
          url: `${api}/api/v1/request/full-request/${id}`,
          timeout: 300000
        })

        if (data && data.status == 'success') {

          this.code = this.$get(data, 'data.request.k3l_request.code', '-')

          this.created_at = moment(
            this.$get(data, 'data.request.k3l_request.createdAt', '-')
          ).format('DD MMM YYYY')

          this.vendor_name = this.$get(data, 'data.nama_vendor', '-')
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'vendorName',
            value: this.vendor_name,
          })

          this.tgl_berdiri = moment(
            this.$get(data, 'data.request.vendor.tanggal_berdiri', '-')
          ).format('DD MMM YYYY')
          this.alamat = this.$get(data, 'data.request.vendor.alamat', '-')
          this.negara = this.$get(
            data,
            'data.request.vendor.negara.negara',
            '-'
          )
          this.provinsi = this.$get(
            data,
            'data.request.vendor.provinsi.desc',
            '-'
          )
          if (this.$get(data, 'data.request.vendor.negara_id') != 63) {
            this.provinsi = this.$get(
              data,
              'data.request.vendor.provinsi_asing',
              '-'
            )
          }
          this.kota = this.$get(data, 'data.request.vendor.kota.desc', '-')
          if (this.$get(data, 'data.request.vendor.negara_id') != 63) {
            this.kota = this.$get(data, 'data.request.vendor.kota_asing', '-')
          }
          this.kecamatan = this.$get(
            data,
            'data.request.vendor.kecamatan.desc',
            '-'
          )
          this.kelurahan = this.$get(
            data,
            'data.request.vendor.kelurahan.desc',
            '-'
          )
          this.jenis_bu = this.$get(
            data,
            'data.request.vendor.badan_usaha.desc',
            '-'
          )
          this.email_vendor = this.$get(data, 'data.request.vendor.email')
          this.phone =
            '+' +
            this.$get(data, 'data.request.vendor.negara.kode_telepon', '') +
            ' ' +
            this.$get(data, 'data.request.vendor.no_handphone')

          this.pic_name = this.$get(data, 'data.request.k3l_request.pic_name')
          this.pic_position = this.$get(
            data,
            'data.request.k3l_request.pic_position'
          )
          this.pic_email = this.$get(data, 'data.request.k3l_request.pic_email')

          // PIC AND PHONE CODE HANDLE START//
          let countryPhoneCode = this.$get(
            data,
            'data.request.vendor.negara.kode_telepon',
            ''
          )
          let picPhoneCode = this.$get(
            data,
            'data.request.k3l_request.pic_phone_code',
            null
          )
          let phone = this.$get(data, 'data.request.k3l_request.pic_phone', '')

          if (picPhoneCode) {
            this.nomor_hp = phone
            // this.nomor_hp = `+${picPhoneCode.replace('+', '')} ${phone}`
          } else {
            this.nomor_hp = `${countryPhoneCode} ${phone}`
          }
          this.phone_code = `+${countryPhoneCode}`
          // PIC AND PHONE CODE HANDLE END//

          this.is_pkp2b = this.$get(
            data,
            'data.request.k3l_request.fix_office_pkp2b'
          )
          this.is_berau = this.$get(
            data,
            'data.request.k3l_request.fix_office_berau'
          )
          this.is_indonesia = this.$get(
            data,
            'data.request.k3l_request.fix_office_indo'
          )

          this.parent_companies = data.data.request.parent_company
          this.child_companies = data.data.request.child_company

          this.usaha_non_inti = JSON.parse(
            data.data.request.k3l_request.non_inti
          )

          this.sertifikat_karyawan =
            data.data.request.request_sertifikat_karyawan

          this.penjelasan_11 = this.$get(
            data,
            'data.request.k3l_request.group_1_desc'
          )
          this.penjelasan_21 = this.$get(
            data,
            'data.request.k3l_request.group_2_desc'
          )
          this.penjelasan_22 = this.$get(
            data,
            'data.request.k3l_request.group_22_desc'
          )
          this.penjelasan_31 = this.$get(
            data,
            'data.request.k3l_request.group_3_desc'
          )
          this.penjelasan_41 = this.$get(
            data,
            'data.request.k3l_request.group_4_desc'
          )
          this.penjelasan_51 = this.$get(
            data,
            'data.request.k3l_request.group_5_desc'
          )
          this.penjelasan_61 = JSON.parse(
            this.$get(data, 'data.request.k3l_request.golden_rules')
          )
          this.system_manajement = data.data.request.request_sertifikasi
          this.penjelasan_81 = this.$get(
            data,
            'data.request.k3l_request.group_8_desc'
          )
          this.penjelasan_82 = this.$get(
            data,
            'data.request.k3l_request.group_82_desc'
          )

          this.izin_11 = this.$get(data, 'data.request.k3l_penilaian.izin_11')
          this.izin_12 = this.$get(data, 'data.request.k3l_penilaian.izin_12')

          this.sertifikat_11 = this.$get(
            data,
            'data.request.k3l_penilaian.sertifikat_11'
          )
          this.sertifikat_12 = this.$get(
            data,
            'data.request.k3l_penilaian.sertifikat_12'
          )
          this.sertifikat_13 = this.$get(
            data,
            'data.request.k3l_penilaian.sertifikat_13'
          )

          this.penilaian_grup1_11 = this.$get(
            data,
            'data.request.k3l_penilaian.penilaian_grup1_11'
          )
          this.penilaian_grup2_11 = this.$get(
            data,
            'data.request.k3l_penilaian.penilaian_grup2_11'
          )
          this.penilaian_grup2_12 = this.$get(
            data,
            'data.request.k3l_penilaian.penilaian_grup2_12'
          )
          this.penilaian_grup3_11 = this.$get(
            data,
            'data.request.k3l_penilaian.penilaian_grup3_11'
          )
          this.penilaian_grup4_11 = this.$get(
            data,
            'data.request.k3l_penilaian.penilaian_grup4_11'
          )
          this.penilaian_grup5_11 = this.$get(
            data,
            'data.request.k3l_penilaian.penilaian_grup5_11'
          )
          this.penilaian_grup6_11 = this.$get(
            data,
            'data.request.k3l_penilaian.penilaian_grup6_11'
          )
          this.penilaian_grup6_12 = this.$get(
            data,
            'data.request.k3l_penilaian.penilaian_grup6_12'
          )
          this.penilaian_grup7_11 = this.$get(
            data,
            'data.request.k3l_penilaian.penilaian_grup7_11'
          )
          this.penilaian_grup7_12 = this.$get(
            data,
            'data.request.k3l_penilaian.penilaian_grup7_12'
          )
          this.penilaian_grup8_11 = this.$get(
            data,
            'data.request.k3l_penilaian.penilaian_grup8_11'
          )

          this.note_izin_11 = this.$get(
            data,
            'data.request.k3l_penilaian.note_izin_11'
          )
          this.note_izin_12 = this.$get(
            data,
            'data.request.k3l_penilaian.note_izin_12'
          )
          this.note_sertifikat_11 = this.$get(
            data,
            'data.request.k3l_penilaian.note_sertifikat_11'
          )
          this.note_sertifikat_12 = this.$get(
            data,
            'data.request.k3l_penilaian.note_sertifikat_12'
          )
          this.note_sertifikat_13 = this.$get(
            data,
            'data.request.k3l_penilaian.note_sertifikat_13'
          )
          this.note_grup1_11 = this.$get(
            data,
            'data.request.k3l_penilaian.note_grup1_11'
          )
          this.note_grup2_11 = this.$get(
            data,
            'data.request.k3l_penilaian.note_grup2_11'
          )
          this.note_grup2_12 = this.$get(
            data,
            'data.request.k3l_penilaian.note_grup2_12'
          )
          this.note_grup3_11 = this.$get(
            data,
            'data.request.k3l_penilaian.note_grup3_11'
          )
          this.note_grup4_11 = this.$get(
            data,
            'data.request.k3l_penilaian.note_grup4_11'
          )
          this.note_grup5_11 = this.$get(
            data,
            'data.request.k3l_penilaian.note_grup5_11'
          )
          this.note_grup6_11 = this.$get(
            data,
            'data.request.k3l_penilaian.note_grup6_11'
          )
          this.note_grup6_12 = this.$get(
            data,
            'data.request.k3l_penilaian.note_grup6_12'
          )
          this.note_grup7_11 = this.$get(
            data,
            'data.request.k3l_penilaian.note_grup7_11'
          )
          this.note_grup7_12 = this.$get(
            data,
            'data.request.k3l_penilaian.note_grup7_12'
          )
          this.note_grup8_11 = this.$get(
            data,
            'data.request.k3l_penilaian.note_grup8_11'
          )

          this.rating_result_1 = this.$get(
            data,
            'data.request.k3l_penilaian.rating_result_1'
          )
          this.rating_result_2 = this.$get(
            data,
            'data.request.k3l_penilaian.rating_result_2'
          )
          this.rating_result_3 = this.$get(
            data,
            'data.request.k3l_penilaian.rating_result_3'
          )
          this.grand_total = this.$get(
            data,
            'data.request.k3l_penilaian.total_result'
          )

          this.updated_at = moment(
            this.$get(data, 'data.request.k3l_penilaian.submit_penilaian', '-')
          ).isValid()
            ? moment(
              this.$get(
                data,
                'data.request.k3l_penilaian.submit_penilaian',
                '-'
              )
            ).format('DD MMM YYYY')
            : '-'
          this.tgl_berlaku = moment(
            this.$get(data, 'data.request.k3l_penilaian.tgl_berakhir', '-')
          ).isValid()
            ? moment(
              this.$get(data, 'data.request.k3l_penilaian.tgl_berakhir', '-')
            ).format('DD MMM YYYY')
            : '-'

          this.kategori =
            this.grand_total && this.k3lKplhCategory(Number(this.grand_total))

          this.usaha_inti = data.data.request.vendor.iujp
          this.usaha_utama = data.data.request.vendor.kbli

          this.actual_g1()
          this.actual_g2()
          this.actual_g3()
        }

        this.$store.commit('SET_GLOBAL_LOADING', false)
      } catch (error) {

        this.$store.commit('SET_GLOBAL_LOADING', false)
      }
    },
    actual_g1() {
      let alocation = 0
      let bobot_1 = 25
      let bobot_2 = 75
      let devider = 2
      let item_1 = this.izin_11
      let item_2 = this.izin_12

      if (item_1 == 'N/A') {
        devider -= 1
        alocation += bobot_1
        bobot_1 = 0
      }

      if (item_2 == 'N/A') {
        devider -= 1
        alocation += bobot_2
        bobot_2 = 0
      }

      this.actual_izin_11 = item_1 == 'N/A' ? 0 : bobot_1 + alocation / devider
      this.actual_izin_12 = item_2 == 'N/A' ? 0 : bobot_2 + alocation / devider
    },
    actual_g2() {
      let alocation = 0
      let bobot = 33.33
      let total_bobot = 100
      let devider = 3
      let item_1 = this.sertifikat_11
      let item_2 = this.sertifikat_12
      let item_3 = this.sertifikat_13

      if (item_1 == 'N/A') {
        devider -= 1
        alocation += bobot
      }

      if (item_2 == 'N/A') {
        devider -= 1
        alocation += bobot
      }

      if (item_3 == 'N/A') {
        devider -= 1
        alocation += bobot
      }

      this.actual_sertifikat_11 =
        devider == 0 || item_1 == 'N/A' ? 0 : (total_bobot / devider).toFixed(2)
      this.actual_sertifikat_12 =
        devider == 0 || item_2 == 'N/A' ? 0 : (total_bobot / devider).toFixed(2)
      this.actual_sertifikat_13 =
        devider == 0 || item_3 == 'N/A' ? 0 : (total_bobot / devider).toFixed(2)
    },
    actual_g3() {
      let alocation = 0
      let bobot_1 = 7.7
      let bobot_2 = 15.4
      let devider = 11
      let item_1 = this.penilaian_grup1_11
      let item_2 = this.penilaian_grup2_11
      let item_3 = this.penilaian_grup2_12
      let item_4 = this.penilaian_grup3_11
      let item_5 = this.penilaian_grup4_11
      let item_6 = this.penilaian_grup5_11
      let item_7 = this.penilaian_grup6_11
      let item_8 = this.penilaian_grup6_12
      let item_9 = this.penilaian_grup7_11
      let item_10 = this.penilaian_grup7_12
      let item_11 = this.penilaian_grup8_11

      if (item_1 == 'N/A') {
        devider -= 1
        alocation += bobot_1
      }
      if (item_2 == 'N/A') {
        devider -= 1
        alocation += bobot_1
      }
      if (item_3 == 'N/A') {
        devider -= 1
        alocation += bobot_1
      }
      if (item_4 == 'N/A') {
        devider -= 1
        alocation += bobot_1
      }
      if (item_5 == 'N/A') {
        devider -= 1
        alocation += bobot_1
      }
      if (item_6 == 'N/A') {
        devider -= 1
        alocation += bobot_1
      }
      if (item_7 == 'N/A') {
        devider -= 1
        alocation += bobot_1
      }
      if (item_8 == 'N/A') {
        devider -= 1
        alocation += bobot_2
      }
      if (item_9 == 'N/A') {
        devider -= 1
        alocation += bobot_1
      }
      if (item_10 == 'N/A') {
        devider -= 1
        alocation += bobot_2
      }
      if (item_11 == 'N/A') {
        devider -= 1
        alocation += bobot_1
      }

      this.actual_penilaian_grup1_11 =
        devider == 0 || item_1 == 'N/A'
          ? 0
          : (bobot_1 + alocation / devider).toFixed(2)
      this.actual_penilaian_grup2_11 =
        devider == 0 || item_2 == 'N/A'
          ? 0
          : (bobot_1 + alocation / devider).toFixed(2)
      this.actual_penilaian_grup2_12 =
        devider == 0 || item_3 == 'N/A'
          ? 0
          : (bobot_1 + alocation / devider).toFixed(2)
      this.actual_penilaian_grup3_11 =
        devider == 0 || item_4 == 'N/A'
          ? 0
          : (bobot_1 + alocation / devider).toFixed(2)
      this.actual_penilaian_grup4_11 =
        devider == 0 || item_5 == 'N/A'
          ? 0
          : (bobot_1 + alocation / devider).toFixed(2)
      this.actual_penilaian_grup5_11 =
        devider == 0 || item_6 == 'N/A'
          ? 0
          : (bobot_1 + alocation / devider).toFixed(2)
      this.actual_penilaian_grup6_11 =
        devider == 0 || item_7 == 'N/A'
          ? 0
          : (bobot_1 + alocation / devider).toFixed(2)
      this.actual_penilaian_grup6_12 =
        devider == 0 || item_8 == 'N/A'
          ? 0
          : (bobot_2 + alocation / devider).toFixed(2)
      this.actual_penilaian_grup7_11 =
        devider == 0 || item_9 == 'N/A'
          ? 0
          : (bobot_1 + alocation / devider).toFixed(2)
      this.actual_penilaian_grup7_12 =
        devider == 0 || item_10 == 'N/A'
          ? 0
          : (bobot_2 + alocation / devider).toFixed(2)
      this.actual_penilaian_grup8_11 =
        devider == 0 || item_11 == 'N/A'
          ? 0
          : (bobot_1 + alocation / devider).toFixed(2)
    },
  },
}
</script>
